import { render, staticRenderFns } from "./RelatorioUso.vue?vue&type=template&id=5c4b836c&scoped=true"
import script from "./RelatorioUso.vue?vue&type=script&lang=js"
export * from "./RelatorioUso.vue?vue&type=script&lang=js"
import style0 from "./RelatorioUso.vue?vue&type=style&index=0&id=5c4b836c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4b836c",
  null
  
)

export default component.exports